import Component from "@glimmer/component";
import { action } from "@ember/object";
import { service } from "@ember/service";
import { on } from "@ember/modifier";
import { fn } from "@ember/helper";
import { i18n } from "discourse-i18n";

export default class WazeAppLauncher extends Component {
  @service site;

  @action
  windowOpenTargetBlank(path) {
    window.open(path, "_blank");
  }

  <template>
    {{#unless this.site.mobileView}}
      <li class="wz-app-launcher">
        <wz-app-launcher
          class="wz-app-launcher"
          title={{i18n "waze.app_launcher.title"}}
        >
          <wz-app-launcher-item
            icon="livemap"
            {{on "click" (fn this.windowOpenTargetBlank "/live-map")}}
          >
            {{i18n "waze.app_launcher.livemap"}}
          </wz-app-launcher-item>
          <wz-app-launcher-item
            icon="editor"
            {{on "click" (fn this.windowOpenTargetBlank "/editor")}}
          >
            {{i18n "waze.app_launcher.map_editor"}}
          </wz-app-launcher-item>
          <wz-app-launcher-item
            icon="forums"
            {{on "click" (fn this.windowOpenTargetBlank "/forum")}}
          >
            {{i18n "waze.app_launcher.forums"}}
          </wz-app-launcher-item>
          <wz-app-launcher-item
            icon="wazeopedia"
            {{on "click" (fn this.windowOpenTargetBlank "/wiki")}}
          >
            {{i18n "waze.app_launcher.wazeopedia"}}
          </wz-app-launcher-item>
          <wz-app-launcher-item
            icon="partners"
            {{on "click" (fn this.windowOpenTargetBlank "/partnerhub")}}
          >
            {{i18n "waze.app_launcher.partner_hub"}}
          </wz-app-launcher-item>
        </wz-app-launcher>
      </li>
    {{/unless}}
  </template>
}
